import { StrictMode } from 'react';
import { render } from 'react-dom';
import { BugsnagErrorBoundary } from './bugsnag/BugsnagErrorBoundary';
import { App, AppProviders } from './components/App';
import '@amzn/ring-safe-web/styles/font.global.css';
import '@amzn/ring-safe-web/styles/color.global.css';
import './i18n';

render(
  <StrictMode>
    <BugsnagErrorBoundary>
      <AppProviders>
        <App />
      </AppProviders>
    </BugsnagErrorBoundary>
  </StrictMode>,
  document.getElementById('root'),
);
